import styled, {css} from "styled-components"

import Icon from "../../Icon"

export default styled.div<{isOpen?: boolean}>`
  width: 36px;
  height: 36px;
  min-width: 36px;
  border: 1px solid ${({theme}) => theme.colors.greys.grey20};
  border-radius: 50%;
  position: relative;
  ${Icon} {
    position: absolute;
    margin: -4px 0 0 -4px;
    top: 13px;
    left: 15px;
    ${({isOpen}) =>
      isOpen &&
      css`
        transform: rotate(90deg);
        top: 14px;
        left: 13px;
      `}
  }
`
